export function toUtc(date: Date | string) {
  const newDate = new Date(date);
  return new Date(newDate.getTime() + newDate.getTimezoneOffset() * 60000);
}

export function toLocal(date: Date | string) {
  return new Date(date);
}
